import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, IconButton } from '@redlink/components/atoms';
import { DataGridColumn } from './dataGridColumn';

export const DataGridActionsColumn = memo(
  ({ actions = [], renderColumn, hovered, ...rest }) => {
    const { styles, colors } = useStyle();
    return (
      <DataGridColumn
        {...rest}
        renderColumn={(dataItem) => (
          <View style={styles.actionsContainer}>
            {actions.map((item) => {
              const color = hovered ? colors.blue1 : colors.gray22;
              return (
                <>
                  <IconButton
                    style={[
                      styles.actionButtonContainer,
                      hovered && styles.actionsContainerHover,
                    ]}
                    onPress={() => item.onPress(dataItem)}
                    disabled={item.disabled}
                  >
                    {item.renderIcon?.(color)}
                  </IconButton>
                  <Space />
                </>
              );
            })}
          </View>
        )}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  simpleText: {
    color: colors.gray23,
    fontSize: 14,
  },
  simpleTextHover: {
    color: colors.blue1,
  },
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionsContainerHover: {
    backgroundColor: colors.blue8,
  },
  actionButtonContainer: {
    backgroundColor: colors.transparent,
  },
}));
